module.exports = __webpack_public_path__ + "static/media/bhim_upi_logo.b0a0731c.png";